export const inlineEditToolFormNamePrefix = 'inline-edit-tool-form-';

const generateInlineEditToolFormName = uuid =>
  inlineEditToolFormNamePrefix + uuid;

export default generateInlineEditToolFormName;
